export enum ActionType {
    Process,
    MarkComplete,
    Cancel,
}

export default class ActionNoticeRequest {

    public investorInvestmentNoticeRequestId: number = 0;

    public action: ActionType | null = null;

    // Client only properties / methods
}